import gql from 'graphql-tag'

export const ADD_GIVE_OGV = gql`
  mutation insertOGF($object: [ongoing_feedback_lists_insert_input!]!) {
    insert_ongoing_feedback_lists(objects: $object) {
      affected_rows
    }
  }
`
